import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import getDataSet from '../../_util/getDataSet';
import ResultInt from '../../_interface/result-int';
function isKeyedFunctionsEqual(keyedFunc1, keyedFunc2) {
    var result = false;
    if (keyedFunc1.func !== keyedFunc2.func) {
        return result;
    }
    if (!keyedFunc1.key && !keyedFunc2.key || keyedFunc1.key === keyedFunc2.key) {
        result = true;
    }
    return result;
}
function keyedFuncEqualsTo(other, inSet) {
    var result = null;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Array.from(inSet)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var value = _step.value;

            if (isKeyedFunctionsEqual(value, other)) {
                result = value;
                break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator['return']) {
                _iterator['return']();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return result;
}
function keyedFuncWithKey(key, inSet) {
    var result = null;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = Array.from(inSet)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var value = _step2.value;

            if (value.key === key) {
                result = value;
                break;
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2['return']) {
                _iterator2['return']();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return result;
}
export var Container = function () {
    function Container() {
        var _this = this;

        _classCallCheck(this, Container);

        this.resumeEventStack = new Map();
        this.pauseEventStack = new Map();
        this.backEventStack = new Map();
        this.eventListenersMap = new Map();
        this.timeStampForEventPrevious = 0;
        this.timeStampForEventPreviousPause = 0;
        this.timeStampForEventPreviousResume = 0;
        this.onContainerPauseEvent = function () {
            _this.throttlePause(function () {
                window.console.info('onContainerPauseEvent');
                _this.pauseEventStack.forEach(function (eventHandle) {
                    try {
                        eventHandle();
                    } catch (_a) {}
                });
            }, 200);
        };
        this.onContainerResumeEvent = function () {
            window.console.info('onContainerResumeEvent');
            _this.throttleResume(function () {
                _this.resumeEventStack.forEach(function (eventHandle) {
                    try {
                        eventHandle();
                    } catch (error) {
                        window.console.info('onContainerResumeEvent error', error);
                    }
                });
            }, 200);
        };
        this.onContainerResumeEventWithParam = function (data) {
            window.console.info('onContainerResumeEventWithParam');
            _this.throttleResume(function () {
                _this.upLogModule.printLog({
                    level: 'info',
                    tag: 'uplusapi',
                    msg: 'Received event with name onContainerResumeEvent ' + document.title
                });
                _this.resumeEventStack.forEach(function (eventHandle) {
                    try {
                        eventHandle(data);
                    } catch (error) {
                        window.console.info('onContainerResumeEventWithParam error', error);
                    }
                });
            }, 200);
        };
        this.onContainerBackEvent = function () {
            _this.throttle(function () {
                window.console.info('onContainerBackEvent');
                _this.backEventStack.forEach(function (eventHandle) {
                    try {
                        eventHandle();
                    } catch (_a) {}
                });
            }, 200);
        };
        this.onContainerEvent = function (event) {
            _this.upLogModule.printLog({
                level: 'info',
                tag: 'uplusapi',
                msg: 'Received event with name: ' + event.type + ',title: ' + document.title
            });
            var data = event === null || event === void 0 ? void 0 : event.data;
            var eventListeners = _this.eventListenersMap.get(event.type);
            if (eventListeners) {
                window.console.info('onContainerEvent eventListenersMap name ' + event.type + ', size= ' + eventListeners.size);
            } else {
                window.console.info('onContainerEvent eventListenersMap name ' + event.type + ', size =0');
            }
            eventListeners === null || eventListeners === void 0 ? void 0 : eventListeners.forEach(function (keyedFunc) {
                try {
                    keyedFunc.func(data);
                    _this.upLogModule.printLog({
                        level: 'info',
                        tag: 'uplusapi',
                        msg: 'Dispatched event ' + event.type + ' to Func ' + keyedFunc.func.name + '(key: ' + keyedFunc.key + ')'
                    });
                } catch (error) {
                    window.console.info('onContainerEvent ' + event.type + ' error', error);
                }
            });
        };
        this.throttle = function (fn, rateTime) {
            var self = _this;
            if (Date.now() - self.timeStampForEventPrevious >= rateTime) {
                fn.apply(_this);
                self.timeStampForEventPrevious = Date.now();
            }
        };
        this.throttlePause = function (fn, rateTime) {
            var self = _this;
            if (Date.now() - self.timeStampForEventPreviousPause >= rateTime) {
                fn.apply(_this);
                self.timeStampForEventPreviousPause = Date.now();
            }
        };
        this.throttleResume = function (fn, rateTime) {
            var self = _this;
            if (Date.now() - self.timeStampForEventPreviousResume >= rateTime) {
                fn.apply(_this);
                self.timeStampForEventPreviousResume = Date.now();
            }
        };
    }
    // abstract initModules(): void;


    _createClass(Container, [{
        key: 'addBackEventListener',
        value: function addBackEventListener(eventListener, keyName) {
            if (typeof eventListener === 'function' && keyName != null) {
                this.backEventStack.set(keyName, eventListener);
                window.console.log('back event stack size:' + this.backEventStack.size);
                return Promise.resolve(new ResultInt('000000', '\u6DFB\u52A0\u76D1\u542C\u5668' + keyName + '\u6210\u529F'));
            } else {
                return Promise.reject(new ResultInt('000001', '添加监听器失败'));
            }
        }
    }, {
        key: 'addPauseEventListener',
        value: function addPauseEventListener(eventListener, keyName) {
            if (typeof eventListener === 'function' && keyName != null) {
                this.pauseEventStack.set(keyName, eventListener);
                window.console.log('pause event stack size:' + this.pauseEventStack.size);
                return Promise.resolve(new ResultInt('000000', '\u6DFB\u52A0\u76D1\u542C\u5668' + keyName + '\u6210\u529F'));
            } else {
                return Promise.reject(new ResultInt('000001', '添加监听器失败'));
            }
        }
    }, {
        key: 'addResumeEventListener',
        value: function addResumeEventListener(eventListener, keyName) {
            if (typeof eventListener === 'function' && keyName != null) {
                window.console.log('addResumeEventListener keyName:' + keyName);
                this.resumeEventStack.set(keyName, eventListener);
                window.console.log('resume event stack size:' + this.resumeEventStack.size);
                return Promise.resolve(new ResultInt('000000', '\u6DFB\u52A0\u76D1\u542C\u5668' + keyName + '\u6210\u529F'));
            } else {
                window.console.log('addResumeEventListener failed keyName:' + keyName);
                return Promise.reject(new ResultInt('000001', '添加监听器失败'));
            }
        }
    }, {
        key: 'addPhysicalBackStack',
        value: function addPhysicalBackStack(eventListener, keyName) {
            if (typeof eventListener === 'function' && keyName != null) {
                this.backEventStack.set(keyName, eventListener);
            }
        }
    }, {
        key: 'removePhysicalBackStack',
        value: function removePhysicalBackStack(keyName) {
            if (keyName != null) {
                this.backEventStack['delete'](keyName);
            } else {
                this.backEventStack.clear();
            }
        }
    }, {
        key: 'removeBackEventListener',
        value: function removeBackEventListener(keyName) {
            if (keyName != null) {
                var isOK = this.backEventStack['delete'](keyName);
                if (isOK) {
                    window.console.log('back event stack size:' + this.backEventStack.size);
                    return Promise.resolve(new ResultInt('000000', '\u79FB\u9664\u76D1\u542C\u5668' + keyName + '\u6210\u529F'));
                } else {
                    return Promise.reject(new ResultInt('000001', '\u76D1\u542C\u5668' + keyName + '\u4E0D\u5B58\u5728'));
                }
            } else {
                this.backEventStack.clear();
                window.console.log('back event stack size:' + this.backEventStack.size);
                return Promise.resolve(new ResultInt('000000', '移除全部监听器成功'));
            }
        }
    }, {
        key: 'removePauseEventListener',
        value: function removePauseEventListener(keyName) {
            if (keyName != null) {
                var isOK = this.pauseEventStack['delete'](keyName);
                if (isOK) {
                    window.console.log('pause event stack size:' + this.pauseEventStack.size);
                    return Promise.resolve(new ResultInt('000000', '\u79FB\u9664\u76D1\u542C\u5668' + keyName + '\u6210\u529F'));
                } else {
                    return Promise.reject(new ResultInt('000001', '\u76D1\u542C\u5668' + keyName + '\u4E0D\u5B58\u5728'));
                }
            } else {
                this.pauseEventStack.clear();
                window.console.log('pause event stack size:' + this.pauseEventStack.size);
                return Promise.resolve(new ResultInt('000000', '移除全部监听器成功'));
            }
        }
    }, {
        key: 'removeResumeEventListener',
        value: function removeResumeEventListener(keyName) {
            if (keyName != null) {
                var isOK = this.resumeEventStack['delete'](keyName);
                if (isOK) {
                    window.console.log('removeResumeEventListener keyName:' + keyName);
                    window.console.log('resume event stack size:' + this.resumeEventStack.size);
                    return Promise.resolve(new ResultInt('000000', '\u79FB\u9664\u76D1\u542C\u5668' + keyName + '\u6210\u529F'));
                } else {
                    window.console.log('removeResumeEventListener failed keyName:' + keyName);
                    return Promise.reject(new ResultInt('000001', '\u76D1\u542C\u5668' + keyName + '\u4E0D\u5B58\u5728'));
                }
            } else {
                this.resumeEventStack.clear();
                window.console.log('resume event stack size:' + this.resumeEventStack.size);
                return Promise.resolve(new ResultInt('000000', '移除全部监听器成功'));
            }
        }
    }, {
        key: 'addEventListener',
        value: function addEventListener(eventName, listenerName, listener) {
            if (typeof listenerName === 'function' && !listener) {
                listener = listenerName;
                listenerName = null;
            }
            if (typeof listener === 'function' && eventName != null) {
                var eventListeners = this.eventListenersMap.get(eventName);
                if (!eventListeners) {
                    document.addEventListener(eventName, this.onContainerEvent, false);
                    eventListeners = new Set();
                    this.eventListenersMap.set(eventName, eventListeners);
                }
                var keyedFunc = { func: listener, key: listenerName };
                if (keyedFuncEqualsTo(keyedFunc, eventListeners) === null) {
                    eventListeners.add(keyedFunc);
                    if (this.upNativeContainerModule) {
                        this.upNativeContainerModule.addEventListener({ eventName: eventName })['catch'](function () {});
                    }
                }
                return Promise.resolve(new ResultInt('000000', '\u6DFB\u52A0' + eventName + '\u76D1\u542C\u5668\u6210\u529F'));
            } else {
                return Promise.reject(new ResultInt('000001', '\u6DFB\u52A0' + eventName + '\u76D1\u542C\u5668\u5931\u8D25'));
            }
        }
    }, {
        key: 'removeEventListener',
        value: function removeEventListener(eventName, listenerName, listener) {
            if (typeof listenerName === 'function' && !listener) {
                listener = listenerName;
                listenerName = null;
            }
            if (eventName != null) {
                var eventListeners = this.eventListenersMap.get(eventName);
                if (!eventListeners) {
                    return Promise.resolve(new ResultInt('000000', '\u79FB\u9664' + eventName + '\u76D1\u542C\u5668\u6210\u529F'));
                }
                var keyedFunc = void 0;
                var hasListener = false;
                if (listenerName) {
                    keyedFunc = keyedFuncWithKey(listenerName, eventListeners);
                    hasListener = keyedFunc != null;
                } else {
                    keyedFunc = keyedFuncEqualsTo({ func: listener }, eventListeners);
                    hasListener = keyedFunc != null;
                }
                if (hasListener && keyedFunc) {
                    eventListeners === null || eventListeners === void 0 ? void 0 : eventListeners['delete'](keyedFunc);
                    if (this.upNativeContainerModule) {
                        this.upNativeContainerModule.removeEventListener({ eventName: eventName })['catch'](function () {});
                    }
                }
                if ((eventListeners === null || eventListeners === void 0 ? void 0 : eventListeners.size) === 0) {
                    this.eventListenersMap['delete'](eventName);
                    document.removeEventListener(eventName, this.onContainerEvent, false);
                }
                return Promise.resolve(new ResultInt('000000', '\u79FB\u9664' + eventName + '\u76D1\u542C\u5668\u6210\u529F'));
            } else {
                return Promise.reject(new ResultInt('000001', '\u79FB\u9664' + eventName + '\u76D1\u542C\u5668\u5931\u8D25'));
            }
        }
    }, {
        key: 'initUplusTrace',
        value: function initUplusTrace() {
            var self = this;
            document.removeEventListener('click', this._uplusTraceHandler.bind(self));
            document.addEventListener('click', this._uplusTraceHandler.bind(self));
        }
    }, {
        key: '_uplusTraceHandler',
        value: function _uplusTraceHandler(event) {
            var elms = event.path || event.composedPath();
            var dataset = getDataSet(elms);
            if (dataset) {
                this.upTraceModule.reportPageClickEvent({
                    actionCode: dataset.id,
                    dataType: dataset.dataType,
                    extentInfo: dataset.data
                });
                if (typeof window.consoleLog === 'function') {
                    window.consoleLog(dataset.id);
                }
            }
        }
    }]);

    return Container;
}();